import chroma from 'chroma-js';
import graphReactor from '@/graphReactor';
import highway from '@/plugins/highway';
import store from '@/store';

function queryOperation(payload) {
  console.log('bro', Object.values(payload));
  Object.values(payload).forEach((item) => {
    item.combos.forEach((combo) => {
      graphReactor.exploreInstance.addItem('combo', combo);
    });
    // graphReactor.exploreInstance.updateLayout();

    item.nodes.forEach((node) => {
      graphReactor.exploreInstance.addItem('node', {
        type: 'circle',
        label: node.label,
        tjType: 'custom-node',
        comboId: node.comboId,
        size: 30,
        labelCfg: {
          /* label's position, options: center, top, bottom, left, right */
          position: 'top',
          color: '#fff',
          /* label's offset to the keyShape, 4 by default */
          offset: 2,
          /* label's style */
          style: {
            fontSize: 15,
            fill: '#fff',
            fontWeight: 500,
            fontFamily: 'Poppins',
            color: '#fff',
          },
        },
        style: {
          size: [200],
          stroke: '#fff',
          fill: '#659dbd',
          lineWidth: 1,
          // shadowOffsetX: 10,
          // shadowOffsetY: 10,
          shadowColor: '#659dbd',
          shadowBlur: 10,
        },
        id: node.label, // Generate a unique id
      });
    });
    item.edges.forEach((edge) => {
      graphReactor.exploreInstance.addItem('edge', edge);
    });
  });
  // TODO - don't use it too much
  store.dispatch('gmodule/saveG6ExploreData');
  // graphReactor.exploreInstance.updateLayout();
}

function updateMyNode(val) {
  const updatedNode = graphReactor.exploreInstance.findById(val.id);
  updatedNode.update(val);
}

function nodeSearch(payload) {
  // commenting out this line because we're not able to use this one with our custom nodes
  // const searchNodeItem = graphReactor.exploreInstance.findById(payload);

  // still has one problem that if the nodes will be available with same label then it will pickup only the first node.
  const searchNodeItem = graphReactor.exploreInstance.find('node', (node) => node.get('model').label === payload);
  // Find all focused item and clear their state.
  graphReactor.exploreInstance.findAllByState('node', 'searchEd').forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node, 'searchEd');
  });
  graphReactor.exploreInstance.findAllByState('node', 'searchRelatedEd').forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node, 'searchRelatedEd');
  });
  graphReactor.exploreInstance.findAllByState('edge', 'searchRelatedEd').forEach((edge) => {
    graphReactor.exploreInstance.clearItemStates(edge, 'searchRelatedEd');
  });
  // focus the item that you searched
  searchNodeItem.getNeighbors('node').forEach((neighbor) => {
    // graphReactor.exploreInstance.setItemState(neighbor, 'selected', false);
    graphReactor.exploreInstance.setItemState(neighbor, 'searchRelatedEd', true);
  });
  searchNodeItem.getOutEdges().forEach((edge) => {
    // graphReactor.exploreInstance.setItemState(edge, 'selected', false);
    graphReactor.exploreInstance.setItemState(edge, 'searchRelatedEd', true);
  });
  graphReactor.exploreInstance.focusItem(searchNodeItem);
  highway.excludeDispatcher(payload, ['gmodule/exploreGraphFetch']);

  // disable any focusEd State if there is one
  graphReactor.exploreInstance.setItemState(searchNodeItem, 'searchEd', true);
}

function nodeSearchClear() {
  graphReactor.exploreInstance.findAllByState('node', 'searchEd').forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node, 'searchEd');
  });
}

function nodeSearchFocus(focusNodes) {
  graphReactor.exploreInstance.findAllByState('node', 'searchEd').forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node, 'searchEd');
  });

  graphReactor.exploreInstance.findAllByState('node', 'searchRelatedEd').forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node, 'searchRelatedEd');
  });
  graphReactor.exploreInstance.findAllByState('edge', 'searchRelatedEd').forEach((edge) => {
    graphReactor.exploreInstance.clearItemStates(edge, 'searchRelatedEd');
  });

  // And then get the focusItem [Array] = and then loop through it and set the focusEd state to true
  focusNodes.forEach((nodeId) => {
    const currentNode = graphReactor.exploreInstance.findById(nodeId);
    graphReactor.exploreInstance.setItemState(currentNode, 'searchEd', true);
  });
}

// function uniqueIdGenerate() {
//   // Generate random id for node
//   return Math.random().toString(36).substr(2, 9);
// }

function deleteSelectedNodes(payload) {
  payload.forEach((item) => {
    graphReactor.exploreInstance.removeItem(item);
  });
}

function nodeCreateSelect(payload, selectedNodes) {
  // const uniqueId = uniqueIdGenerate();
  // console.log('payload: ', uniqueId);
  graphReactor.exploreInstance.addItem('node', {
    type: 'circle',
    label: payload.currentLabel,
    tjType: 'custom-node',
    size: 30,
    labelCfg: {
      /* label's position, options: center, top, bottom, left, right */
      position: 'top',
      color: '#fff',
      /* label's offset to the keyShape, 4 by default */
      offset: 2,
      /* label's style */
      style: {
        fontSize: 15,
        fill: '#fff',
        fontWeight: 500,
        fontFamily: 'Poppins',
        color: '#fff',
      },
    },
    style: {
      size: [200],
      stroke: '#fff',
      fill: '#659dbd',
      lineWidth: 1,
      // shadowOffsetX: 10,
      // shadowOffsetY: 10,
      shadowColor: '#659dbd',
      shadowBlur: 10,
    },
    id: payload.currentLabel, // Generate a unique id
  });
  selectedNodes.forEach((node) => {
    graphReactor.exploreInstance.addItem('edge', {
      // eslint-disable-next-line
          source: node._cfg.id,
      target: payload.currentLabel,
      label: payload.currentEdgeLabel,
    });
  });
  console.log('nodeCreateSelect: ', payload);
  // graphReactor.exploreInstance.updateLayout();
  store.dispatch('gmodule/saveG6ExploreData');
}

function comboCreateSelect(label, selectedNodes) {
  // const uniqueId = uniqueIdGenerate();
  const combo = {
    id: label,
    label,
    tjType: 'custom-combo',
    style: {
      lineWidth: 1,
      opacity: 0.3,
      fill: chroma.random().darken().hex(),
    },
  };
  graphReactor.exploreInstance.addItem('combo', combo);
  // const findCombo = graphReactor.exploreInstance.findById(`combo-${uniqueId}`);
  selectedNodes.forEach((node) => {
    // Its a kind of hack but chlta hai
    // eslint-disable-next-line
        const getnode = graphReactor.exploreInstance.findById(node._cfg.id);
    console.log('getnode', getnode.getModel(), getnode.getEdges());
    const newNode = getnode.getModel();
    const newEdgeArray = getnode.getEdges().map((edge) => edge.getModel());
    graphReactor.exploreInstance.removeItem(getnode);
    newNode.comboId = label;
    graphReactor.exploreInstance.addItem('node', newNode);
    newEdgeArray.forEach((edge) => {
      console.log('edge', edge);
      graphReactor.exploreInstance.addItem('edge', edge);
    });
    // graphReactor.exploreInstance.addItem(getnode);
  });
  // this.selectedNodesG6.forEach((node) => {
  //   // eslint-disable-next-line
  //   console.log(node)
  //   // graphReactor.exploreInstance.removeItem(getnode);
  // });
  // TODO - don't use it too much
  store.dispatch('gmodule/saveG6ExploreData');
}

async function addNoteToGraph(item) {
  const userId = `${store.state.auth.user.username}`;
  let node = {};
  switch (item.value.type || 'default-node') {
    case 'note':
      node = {
        id: item.id,
        // label: item.id,
        // description: item.id,
        label: item.value.note.slice(0, 10),
        description: item.value.note,
        tjType: 'note-text',
        tjData: {
          content: item.value.note,
          url: item.value.noteUrl,
        },
        size: 30,
        type: 'circle',
        style: {
          fill: '#876603',
          stroke: '#888',
        },
      };
      break;
    case 'image':
      node = {
        id: item.id,
        label: 'image',
        img: item.value.note || item.value.imageNote,
        type: 'image',
        size: 50,
        tjType: 'note-image',
        tjData: {
          content: item.value.note || item.value.imageNote,
          url: item.value.noteUrl,
        },
        labelCfg: {
          position: 'bottom',
        },
        clipCfg: {
          show: true,
          type: 'circle',
          // circle
          r: 25,
        },
      };
      break;
    case 'recording':
      node = {
        id: item.id,
        // label: item.id,
        // description: item.id,
        label: 'recording',
        description: item.value.note,
        tjType: 'note-recording',
        tjData: {
          content: item.value.note,
          url: item.value.noteUrl,
        },
        size: 30,
        type: 'circle',
        style: {
          fill: '#00ff95',
          stroke: '#888',
        },
      };
      break;

    case '3d':
      node = {
        id: item.id,
        label: item.value.label,
        description: item.value.note,
        tjType: 'note-3d',
        tjData: {
          content: item.value.note,
          url: item.value.noteUrl,
        },
        size: 30,
        type: 'circle',
        style: {
          fill: '#fce181',
          stroke: '#888',
        },
      };
      break;

    case 'page':
      node = {
        id: item.id,
        // label: item.id,
        // description: item.id,
        label: item.value.noteUrl,
        description: item.value.noteUrl,
        tjData: item.value.noteUrl,
        tjType: 'note-page',
        size: 30,
        type: 'circle',
        style: {
          fill: '#8c00ff',
          stroke: '#888',
        },
      };
      break;
    case 'video':
      node = {
        id: item.id,
        // label: item.id,
        // description: item.id,
        label: item.value?.videoLabel || 'video',
        description: item.value.noteUrl,
        tjType: 'note-video',
        tjData: {
          content: item.value.noteUrl,
          url: item.value.noteUrl,
        },
        size: 30,
        type: 'circle',
        style: {
          fill: '#cf0433',
          stroke: '#888',
        },
      };
      break;
    default:
      node = {
        id: item.id,
        // label: item.id,
        // description: item.id,
        label: item.value.note.slice(0, 10),
        description: item.value.note,
        tjData: {
          content: item.value.note,
          url: item.value.noteUrl,
        },
        tjType: 'note-text',
        size: 30,
        type: 'circle',
        style: {
          fill: '#876603',
          stroke: '#888',
        },
      };
  }
  // console.log('note-add-to-graph', item);

  // console.log(`${store.state.userInfo.username}#${store.state.userInfo.discriminator}`);
  if (graphReactor.exploreInstance.findById(userId)) {
    graphReactor.exploreInstance.addItem('node', node);
    const edge = {
      source: userId,
      target: item.id,
      label: 'has noted',
      style: {
        endArrow: true,
      },
    };
    graphReactor.exploreInstance.addItem('edge', edge);
    const mainid = graphReactor.exploreInstance.findById(userId);
    const nodeItem = graphReactor.exploreInstance.findById(item.id);
    nodeItem.refresh();
    mainid.refresh();
    store.commit('gmodule/ADD_NOTE_NODES_EDGES', { type: 'node', data: node });
    store.commit('gmodule/ADD_NOTE_NODES_EDGES', { type: 'edge', data: edge });
    graphReactor.exploreInstance.focusItem(mainid, true);
    // graphReactor.exploreInstance.updateLayout(this.config);
    store.dispatch('gmodule/saveG6ExploreData');
  } else {
    const userNode = {
      id: userId,
      label: `${store.state.auth.user.username}`,
      description: `${store.state.auth.user.username}`,
      tjType: 'user',
      size: 50,
      type: 'circle',
      style: {
        fill: '#b3fff9 ',
        stroke: '#888',
      },
    };
    graphReactor.exploreInstance.addItem('node', userNode);
    const edge = {
      source: userId,
      target: item.id,
      label: 'has noted',
      style: {
        endArrow: true,
      },
    };
    graphReactor.exploreInstance.addItem('node', node);
    graphReactor.exploreInstance.addItem('edge', edge);
    const mainid = graphReactor.exploreInstance.findById(userId);
    const nodeItem = graphReactor.exploreInstance.findById(item.id);
    nodeItem.refresh();
    mainid.refresh();
    store.commit('gmodule/ADD_NOTE_NODES_EDGES', { type: 'node', data: node });
    store.commit('gmodule/ADD_NOTE_NODES_EDGES', { type: 'node', data: userNode });
    store.commit('gmodule/ADD_NOTE_NODES_EDGES', { type: 'edge', data: edge });
    // graphReactor.exploreInstance.updateLayout(this.config);
    // graphReactor.exploreInstance.updateLayout(this.config);
    store.dispatch('gmodule/saveG6ExploreData');
  }
}

function addNodeGraph(data) {
  // const uniqueId = uniqueIdGenerate();
  graphReactor.exploreInstance.addItem('node', {
    x: data?.pos?.x || null,
    y: data?.pos?.y || null,
    size: 30,
    type: 'circle',
    label: data?.label || store.state.newNodeLabel,
    tjType: 'custom-node',
    labelCfg: {
      /* label's position, options: center, top, bottom, left, right */
      position: 'top',
      color: '#fff',
      /* label's offset to the keyShape, 4 by default */
      offset: 2,
      /* label's style */
      style: {
        fontSize: 15,
        fill: '#fff',
        fontWeight: 500,
        fontFamily: 'Poppins',
        color: '#fff',
      },
    },
    style: {
      size: [200],
      stroke: '#fff',
      fill: '#659dbd',
      lineWidth: 1,
      // shadowOffsetX: 10,
      // shadowOffsetY: 10,
      shadowColor: '#659dbd',
      shadowBlur: 10,
    },
    id: data?.label || store.state.newNodeLabel, // Generate a unique id
  });
  graphReactor.exploreInstance.updateLayout();
}

export default {
  queryOperation,
  updateMyNode,
  nodeSearch,
  nodeSearchClear,
  nodeSearchFocus,
  deleteSelectedNodes,
  nodeCreateSelect,
  comboCreateSelect,
  addNoteToGraph,
  addNodeGraph,
};
